import * as React from 'react';
import { DEFAULT_SIZE, DEFAULT_COLOR } from '../types';
import { Child, StyledThreeBounce } from './styles';
const ThreeBounce = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR, className, }) => {
    return (React.createElement(StyledThreeBounce, { className: className, size: size, color: color },
        React.createElement(Child, { delay: -0.32 }),
        React.createElement(Child, { delay: -0.16 }),
        React.createElement(Child, { delay: 0 })));
};
export default ThreeBounce;
//# sourceMappingURL=index.js.map